import { DURATION, EASE, useReducedMotion } from '@/lib/motion-presets';
import { AnimatePresence, motion } from 'motion/react';

type AuthErrorMessageProps = {
	message?: string | null;
};

export default function AuthErrorMessage({ message }: AuthErrorMessageProps) {
	const reducedMotion = useReducedMotion();

	return (
		<div className='flex h-5 items-center justify-center'>
			<AnimatePresence mode='wait'>
				{message ? (
					<motion.p
						key={message}
						className='text-sm text-destructive'
						initial={reducedMotion ? false : { opacity: 0, y: -4 }}
						animate={{ opacity: 1, y: 0 }}
						exit={reducedMotion ? undefined : { opacity: 0, y: -4 }}
						transition={{ duration: DURATION, ease: EASE }}
					>
						{message}
					</motion.p>
				) : null}
			</AnimatePresence>
		</div>
	);
}
